import React, { useEffect, useState } from "react";
import * as style from "./EditValueStreams.module.scss";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ValueStreamsCard from "./ValueStreamCard";
import ConfirmModal from "../../Components/Modals/ConfirmModal";

import { Dialog, DialogTitle, Tab, Tabs } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";

import Button from "../../Components/Common/CprimeButton";
import CustomBreadcrumb from "../../Components/CustomBreadcrumb/CustomBreadcrumb";
import GridTable from "cvmgmt-cube-grid-table";
import { getEnv } from "../../Constants/env";
import { triggerToast } from "../../utils/toast";
import { useSelector } from "react-redux";
import AddApplicationSidePanel from "./AddApplicationSidePanel";
import AddApplicationPanelContent from "./AddApplicationPanelContent";
import { useIdToken } from "../../hooks/useAuthSession";
interface ValueStreamProps {
  isCreatValueStream?: boolean;
  setCreateGroupModal?: any;
}

interface UnMapValueStream {
  data: [];
  message: string;
  error: any;
}

import {
  getUnmappedApplicationStream,
  deleteApplication,
  updateValueStream,
  getDetailsValueStream,
  addApplication,
} from "../../services/RequestAccess/RequestAccess";

const EditValueStreams: React.FC<ValueStreamProps> = ({
  isCreatValueStream = false,
  setCreateGroupModal = () => null,
}) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [name, setName] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [UnMapValueStream, setUnMapValueStream] = useState<UnMapValueStream[]>(
    [],
  );

  const scssClass = style as any;

  const navigate = useNavigate();
  const idToken = useIdToken();
  const [isGroupSidePanelVisible, setIsGroupSidePanelVisible] = useState(false);
  const [descriptionApp, setDescriptionApp] = useState("");
  const [appId, setAppId] = useState("");
  const [modalMessage, setModalMessage] = useState<string>("");
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { env } = useSelector((state: any) => state?.createApplication);

  const fetchValueStreamsData = async () => {
    try {
      const valueStreamsData = await getUnmappedApplicationStream();
      setUnMapValueStream(valueStreamsData?.data);
    } catch (error) {
      triggerToast("Error fetching permissions", "error");
    }
  };
  useEffect(() => {
    fetchValueStreamsData();
  }, []);

  const handleUpdateValueStream = async (name: string, description: string) => {
    try {
      const payload = {
        id: id,
        name: name,
        description: description,
      };
      const response = await updateValueStream(payload);
      if (response?.error) {
        triggerToast(`${response?.error}`, "error");
      } else if (response?.status === true) {
        triggerToast(`${response?.message}`, "success");
        navigate("/value-streams");
      }
      triggerToast(`${response?.message}`, response?.status?.toLowerCase());
    } catch (err) {
      // console.error("Group save failed:", err);
    }
    navigate("/value-streams");
  };

  useEffect(() => {
    if (isCreatValueStream) {
      setIsGroupSidePanelVisible(true);
    }
  }, [isCreatValueStream]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  // const [actionPopup, setActionPopup] = useState(false);
  const [applicationId, setApplicationId] = useState("");

  const { id } = useParams<{ id: string }>();

  const [selectedId, setSelectedId] = useState(id);
  const fetchValueStreamsEditData = async () => {
    try {
      const valueStreamsData = await getDetailsValueStream(id);
      setName(valueStreamsData?.data[0]?.value_stream_name);
      setDescription(valueStreamsData?.data[0]?.description);
    } catch (error) {
      triggerToast("Error fetching permissions", "error");
    }
  };
  useEffect(() => {
    fetchValueStreamsEditData();
  }, []);

  const [refresh, setRefresh] = useState<number>(0);

  // const openActionPopup = () => setActionPopup((prev) => !prev);

  const handleDeleteApiRelation = async (id: any) => {
    try {
      const payload = {
        app_id: id,
      };
      const response = await deleteApplication(payload);
      if (response?.error) {
        triggerToast(`${response?.error}`, "error");
      } else if (response?.status === true) {
        triggerToast(`${response?.message}`, "success");
      }
      triggerToast(`${response?.message}`, response?.status?.toLowerCase());
    } catch (err) {
      // console.error("Group save failed:", err);
    }
    setRefresh((prev) => prev + 1);
    const valueStreamsData = await getUnmappedApplicationStream();
    setUnMapValueStream(valueStreamsData?.data);
    setIsModalOpen(false);
  };

  const addApplicationHandler = async (des: string, appId: Number) => {
    try {
      const payload = {
        app_id: appId,
        value_stream_id: id,
        mapping_description: des,
      };
      const response = await addApplication(payload);
      if (response?.error) {
        triggerToast(`${response?.error}`, "error");
      } else if (response?.status === true) {
        triggerToast(`${response?.message}`, "success");
      }
      triggerToast(`${response?.message}`, response?.status?.toLowerCase());
    } catch (err) {
      // console.error("Group save failed:", err);
    }
    setIsGroupSidePanelVisible(false);
    setRefresh((prev) => prev + 1);
    setDescriptionApp("");
    const valueStreamsData = await getUnmappedApplicationStream();
    setUnMapValueStream(valueStreamsData?.data);
  };

  return (
    <>
      <div className={scssClass.page}>
        <CustomBreadcrumb
          items={[
            {
              label: "Value Streams",
              href: "/value-streams",
              icon: <HomeOutlinedIcon sx={{ color: "#2469FF" }} />,
            },
            {
              label: `Edit Value Stream`,
            },
          ]}
        />
        <div className={scssClass.container} style={{ marginTop: "1rem" }}>
          <div className={scssClass.header}>
            <div className={scssClass.title}>{name ? name : ""}</div>
            {selectedTab === 1 && (
              <Button
                variant="secondary"
                size="small"
                data-testid={"add-app-btn"}
                onClick={() => {
                  setIsGroupSidePanelVisible(true);
                }}
                sx={{ height: "40px", width: "200px" }}
              >
                Add Application
              </Button>
            )}
          </div>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            sx={{
              "& .MuiButtonBase-root": {
                color: "black !important",
                backgroundColor: "white",
              },
              "& .MuiTabs-indicator": {
                color: "black !important",
                backgroundColor: "black !important",
              },
              "& .MuiTabs-root": {
                marginBottom: "0px !important",
              },
            }}
          >
            <Tab
              label="Details"
              sx={{
                textTransform: "none",
                fontWeight: selectedTab === 0 ? "bold" : "",
              }}
            />
            <Tab
              label="Manage Applications"
              sx={{
                textTransform: "none",
                fontWeight: selectedTab === 1 ? "bold" : "",
              }}
            />
          </Tabs>
        </div>

        <div className={scssClass.tableContainer}>
          {selectedTab === 0 && (
            <>
              <ValueStreamsCard
                updateValueStream={handleUpdateValueStream}
                name={name}
                description={description}
                setName={setName}
                setDescription={setDescription}
                group={undefined}
                id={undefined}
                expandedCards={undefined}
                toggleAllFeatures={undefined}
                toggleFeature={undefined}
                handleDelete={undefined}
              />
            </>
          )}

          {selectedTab === 1 && (
            <>
              {id && (
                <GridTable
                  style={{
                    height: "calc(100vh - 33.5rem)",
                    maxWidth: "calc(100vw - 4rem)",
                  }}
                  customPayload={true}
                  isCustomizeColumns={false}
                  title="Application List"
                  apiConfig={{
                    url: `${getEnv()?.baseURL}/valuestream/applications/${selectedId}?env=${env}`,
                    data: {
                      sortingFilter: {
                        filter: [],
                        sort: [],
                        page: {
                          limit: 25,
                          offset: 0,
                        },
                      },
                    },
                    headers: {
                      Authorization: idToken,
                      "x-api-key": "sasa",
                      "Content-Type": "application/json",
                      Accept: "application/json",
                    },
                    documentUrl: "",
                  }}
                  refresh={refresh}
                  cellActions={[
                    {
                      event: "Delete",
                      callback: (event, rows) => {
                        setApplicationId(rows?.row?.original?.id);
                        setIsModalOpen(true);
                      },
                      icon: true,
                    },
                  ]}
                  isPagination={true}
                  showLoader={false}
                />
              )}
            </>
          )}
        </div>
      </div>

      <Dialog
        open={false}
        // open={actionPopup}
        // onClose={openActionPopup}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontWeight: 400,
            fontSize: "24px",
            lineHeight: "32px",
          }}
        ></DialogTitle>
      </Dialog>

      {(isCreatValueStream || isGroupSidePanelVisible) && (
        <AddApplicationSidePanel
          open={isCreatValueStream || isGroupSidePanelVisible}
          addApplicationHandler={addApplicationHandler}
          descriptionApp={descriptionApp}
          appId={appId}
          onClose={() => {
            if (isCreatValueStream) {
              setCreateGroupModal(false);
            }
            setIsGroupSidePanelVisible(false);
          }}
          BodyComponent={
            <AddApplicationPanelContent
              data={UnMapValueStream}
              descriptionValueStream={"setDescription"}
              nameValueStream={undefined}
              descriptionAppHandler={setDescriptionApp}
              setAppId={setAppId}
              descriptionApp={description}
            />
          }
        />
      )}
      <ConfirmModal
        value={modalMessage}
        limitmessage={""}
        modalMessage={""}
        isOpen={isModalOpen}
        headLabel={"Are you sure you want to delete the application"}
        deleteModal={true}
        handleClose={() => {
          setIsModalOpen(false);
          setModalMessage("");
        }}
        handleConfirm={() => handleDeleteApiRelation(applicationId)}
        cancelButtonLabel={"Cancel"}
        confirmButtonLabel={"Delete"}
        confirmButtonStyle="danger"
        handleTextFeild={(value: string) => {
          setModalMessage((prev) => value);
        }}
      />
    </>
  );
};

export default EditValueStreams;
